import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-share-white",
  "use": "default-share-white-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"default-share-white\"><path d=\"M4.526 0A4 4 0 018.47 4.68l6.129 3.54a4 4 0 110 5.56l-6.13 3.54a4 4 0 11-1.175-2.208l6.215-3.588a4.038 4.038 0 010-1.047L7.293 6.89A4 4 0 114.526 0zm0 16.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm12.948-7a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-12.948-7a1.5 1.5 0 100 3 1.5 1.5 0 000-3z\" fill=\"#FFF\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol